const BASE = 200;
const domes = [
  { cx: 180, rx: 30, ry: 38 },
  { cx: 300, rx: 55, ry: 70 },
  { cx: 600, rx: 46, ry: 58 },
  { cx: 720, rx: 72, ry: 96, finial: true },
  { cx: 840, rx: 46, ry: 58 },
  { cx: 1140, rx: 55, ry: 70 },
  { cx: 1260, rx: 30, ry: 38 },
];
const minarets = [470, 970];

const arc = (cx, rx, ry, base) =>
  `M ${cx - rx} ${base} A ${rx} ${ry} 0 0 1 ${cx + rx} ${base} Z`;

// Decorative mosque skyline silhouette anchored to the bottom of the hero.
const MosqueSkyline = ({ className = "" }) => (
  <svg
    aria-hidden
    viewBox="0 0 1440 240"
    preserveAspectRatio="xMidYMax slice"
    className={className}
    fill="currentColor"
  >
    <rect x="0" y={BASE} width="1440" height={240 - BASE} />

    {domes.map((d) => (
      <path key={d.cx} d={arc(d.cx, d.rx, d.ry, BASE)} />
    ))}

    {/* central dome finial */}
    <rect x="718" y="84" width="4" height="22" />
    <circle cx="720" cy="80" r="6" />

    {minarets.map((x) => (
      <g key={x}>
        <rect x={x - 8} y="64" width="16" height={BASE - 64} />
        <path d={arc(x, 15, 22, 64)} />
        <rect x={x - 14} y="112" width="28" height="7" rx="2" />
        <rect x={x - 1.5} y="36" width="3" height="20" />
        <circle cx={x} cy="34" r="5" />
      </g>
    ))}
  </svg>
);

export default MosqueSkyline;
